export default __webpack_public_path__ + "static/Stefan-759c6d1880266b4a705f009b7209d67b.png";